var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 194,
    viewBox: "0 0 364 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M362.693 -111.635L250.49 2.34647C204.78 48.782 138.352 64.2194 78.4167 42.335L48.072 31.2551C15.283 19.2827 -20.1938 23.2589 -49.3792 40.9197M-127.028 8.00914L-69.5401 31.2972C-62.6465 34.0897 -55.9151 37.303 -49.3792 40.9197M-49.3792 40.9197C-45.8531 42.871 -42.3839 44.9396 -38.9769 47.123L-2.92382 70.2275C5.37549 75.5462 12.0236 83.3212 16.1989 92.592C25.0602 112.268 21.5364 135.681 7.34132 151.442L-5.73625 165.963C-14.7811 176.007 -26.2964 183.175 -38.9861 186.662L-54.2013 190.843C-69.7555 195.118 -86.2813 190.058 -97.2943 177.651C-106.46 167.325 -110.689 153.147 -108.784 139.13L-106.139 119.664C-103.662 101.434 -95.8058 84.5057 -83.6933 71.2965L-75.5609 62.4277C-67.706 53.8615 -58.8756 46.6662 -49.3792 40.9197Z",
    stroke: "#F8F3A2",
    strokeWidth: 2,
    strokeDasharray: "10 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeft);
export default __webpack_public_path__ + "static/media/top-left.c9012a13201c7097061c89f0664932df.svg";
export { ForwardRef as ReactComponent };